import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {
    CalendarModule,
    CheckboxModule,
    ConfirmDialogModule,
    EditorModule,
    FileUploadModule,
    InputSwitchModule,
    InputTextModule,
    RadioButtonModule,
    SharedModule
} from 'primeng/primeng';

import {CadensSharedModule} from '../../shared';
import {CadensAdminModule} from '../../admin/admin.module';

import {InformationComponent} from './information/information.component';
import {ChoixComponent} from './choix/choix.component';
import {QuestionComponent} from './question/question.component';
import {ReponseComponent} from './reponse/reponse.component';
import {DemandeModifComponent} from './demande-modif/demande-modif.component';
import {DemandeModifService} from './demande-modif/demande-modif.service';
import {ParametreComponent} from './parametre/parametre.component';
import {PieceComponent} from './piece/piece.component';
import {CommissionComponent} from './commission/commission.component';

@NgModule({
    imports: [
        CadensSharedModule,
        CadensAdminModule,
        FileUploadModule,
        InputTextModule,
        CalendarModule,
        InputSwitchModule,
        EditorModule,
        RadioButtonModule,
        CheckboxModule,
        SharedModule,
        ConfirmDialogModule
    ],
    declarations: [
        InformationComponent,
        QuestionComponent,
        ReponseComponent,
        DemandeModifComponent,
        ParametreComponent,
        PieceComponent,
        CommissionComponent,
        ChoixComponent
    ],
    entryComponents: [
    ],
    exports: [
        InformationComponent,
        QuestionComponent,
        ReponseComponent,
        DemandeModifComponent,
        ParametreComponent,
        PieceComponent,
        CommissionComponent,
        ChoixComponent
    ],
    providers: [
        DemandeModifService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensBlocksModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/blocks.module.ts